import { render, staticRenderFns } from "./feedback-form.html?vue&type=template&id=7f52a080&scoped=true&external"
import script from "./feedback-form.js?vue&type=script&lang=js&external"
export * from "./feedback-form.js?vue&type=script&lang=js&external"
import style0 from "./feedback-form.scss?vue&type=style&index=0&id=7f52a080&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f52a080",
  null
  
)

export default component.exports